import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';
import { DEFAULT_LANGUAGE, isLanguageCode, LanguageCode } from './language';
import { TRANSLATIONS } from './translations';

@Injectable({ providedIn: 'root' })
export class LocalizationService {
  private readonly document = inject(DOCUMENT);
  private readonly languageState = signal<LanguageCode>(DEFAULT_LANGUAGE);
  readonly language = this.languageState.asReadonly();

  use(value: unknown): LanguageCode {
    const language =
      typeof value === 'string' && isLanguageCode(value.toLowerCase())
        ? (value.toLowerCase() as LanguageCode)
        : DEFAULT_LANGUAGE;
    this.languageState.set(language);
    this.document.documentElement.lang = language;
    return language;
  }

  translate(key: string): string {
    return TRANSLATIONS[this.languageState()][key] ?? key;
  }
}
